import c from "./ShortNewsContentPart.module.scss"
import {useEffect, useState} from "react";
import Helpers from "../../helpers/Helpers";

export default function ShortNewsContentPart({}){
	const [shortNews, setShortNews]	= useState();

	useEffect(() => {
		if (!shortNews){
			getShortNews();
		}
	}, []);

	const getShortNews = async () => {
		let items = await Helpers.searchPaginated('shortNews', null, null, {limit: 10});
		if (items.mainObj?.length>0){
			setShortNews(items.mainObj);
		}
	}

	return <div className={c.root}>
		<div className={c.folgBat}>Følg båtbransjen</div>
		<ul>
		{shortNews?shortNews.map((s, i)=>{
			return <li key={i}>
				{s.image&&<img src={Helpers.getImageSrcFromResource('shortNews', s._id, s.image)}/>}
				<div dangerouslySetInnerHTML={{__html:s.name}}></div>
			</li>
		}):<li>Loading...</li>}
		</ul>
	</div>
}


